module.exports = "/_next/static/images/EthnusTech-8e8b7f2cd02fad394e8dad7e2a521c1e.jpg";